const FakeSelectTabs = {
  el: {
    root: document.querySelectorAll('.tabs__wrapper'),
  },

  init() {
    if (this.el.root) {
      this.el.root.forEach((target) => {
        const el = {
          root: target,
          tabPanels: Array.from(target.querySelectorAll('[role=tabpanel]')),
          buttons: Array.from(target.querySelectorAll('[role=tab]')),
          activeTab: target.querySelector('[role=tab][aria-selected=true]'),
          tablist: target.querySelector('[role=tablist]'),
          query: window.location.search,
          searchParams: new URLSearchParams(window.location.search),
        }

        this.bind(el, el.root)

        if (el.searchParams.has('t')) {
          const activeTab = el.searchParams.get('t')
          const activeBtn = el.buttons.filter((btn) => btn.getAttribute('aria-controls') === activeTab)

          this.setActiveTab(el, el.root, activeBtn[0])
        } else {
          this.setActiveTab(el, el.root, el.activeTab)
        }
      })
    }
  },

  updateTrigger(item: HTMLElement) {
    const wrapper = item.querySelector('.fake-select__wrap')
    wrapper.classList.toggle('open')
  },

  setSelectText(item: Element, button: Element) {
    const fakeSelectText = item.querySelector('.fake-select__text')
    fakeSelectText.innerHTML = button.textContent
  },

  setActiveTab(el, item: Element, button: Element) {
    let lastActiveElement = el.activeTab

    //* cover if there is a url tab parameter but no tab in the html
    if (!lastActiveElement) {
      lastActiveElement = document.querySelector('[aria-controls="1"]')
    }
    if (button == null) {
      button = document.querySelector('[aria-controls="1"]')
    }

    this.setSelectText(item, button)
    lastActiveElement.setAttribute('aria-selected', 'false')
    lastActiveElement.classList.remove('fake-select__item--active')

    button.setAttribute('aria-selected', 'true')
    button.classList.add('fake-select__item--active')

    el.activeTab = button

    //* close the old open one
    const lastPanelControl = lastActiveElement.getAttribute('aria-controls')

    if (lastPanelControl) {
      const lastPanel = el.tabPanels.find((x) => x.id === lastPanelControl)
      if (lastPanel) {
        lastPanel.setAttribute('aria-expanded', 'false')
      }
    }

    //* set the new tab to open
    const ariaControl = button.getAttribute('aria-controls')

    //* update url parameters
    el.searchParams.set('t', ariaControl)
    const newUrl = `${window.location.protocol}//${window.location.host}${
      window.location.pathname
    }?${el.searchParams.toString()}`
    window.history.pushState({ path: newUrl }, '', newUrl)

    if (ariaControl) {
      const panel = el.tabPanels.find((x) => x.id === ariaControl)
      if (panel) {
        panel.setAttribute('aria-expanded', 'true')
      }
    }
  },

  bind(el, item) {
    const trigger = item.querySelector('.fake-select__trigger')

    trigger.addEventListener('click', () => {
      this.updateTrigger(item)
    })

    el.buttons.map((button) => {
      button.addEventListener('click', () => {
        this.updateTrigger(item)
        this.setActiveTab(el, item, button)
      })
    })
  },
}

export default FakeSelectTabs
